import React from 'react';
import { ExternalProviderCard } from './ExternalProviderCard/index';
import { Button } from '../../../../components/Button/index';
import { Trans, i18nMark } from 'lingui-react';

import addExternal from '../../../../assets/images/addExternal.svg';

import './externalProviders.css';

export const ExternalProviders = props => {
  const externalITProviders = props.externalITProviders.map((ep, index) => {
    return <ExternalProviderCard
      titleCard={<Trans id="Service Provider" />}
      labelCompanyName={props.i18n._(i18nMark('Company Name'))}
      placeHolderCompanyName={props.i18n._(i18nMark('Your company name'))}
      labelFirstName={props.i18n._(i18nMark('First Name'))}
      placeHolderFirstName={props.i18n._(i18nMark('First Name'))}
      labelLastName={props.i18n._(i18nMark('Last Name'))}
      placeHolderLastName={props.i18n._(i18nMark('Last Name'))}
      labelPhoneNumber={props.i18n._(i18nMark('Phone Number'))}
      placeHolderPhoneNumber={props.i18n._(i18nMark('Phone Number'))}
      labelEmail={props.i18n._(i18nMark('Email'))}
      placeHolderEmail={props.i18n._(i18nMark('Email'))}
      externalITProvider={ep}
      onClickClose={props.onClickRemoveExternalProvider}
      index={index}
      key={index}
      validationMessages={props.validationMessages}
      onInputChange={props.onInputChange}
      {...this.props}
    />
  })
  return (
    <div className="company-external-provider">
      <div className="title-card">
        <span className="title-number">2</span>{<Trans id="External IT Provider" />}
      </div>
      {externalITProviders}
      <Button iconSource={addExternal} styleButton="external-it-button"
        text={externalITProviders.length > 0 ? <Trans id="Add IT provider" /> : <Trans id="Add external IT provider" />} onClick={props.onClickAddExternalProvider}
        id="btnExternalItProvider" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Company/components/ExternalProviders/ExternalProviders.js